module.exports = __webpack_public_path__ + "static/media/7.3595c692.png";